import { Session } from "src/modules/interface";
import { FacilityShift } from "../../types";
interface GetWorkerLeftEarlyMetadataParams {
  user: Session["user"];
  shift: Pick<
    FacilityShift,
    "_id" | "agentId" | "canRequestReplacement" | "facility" | "start" | "clockInOut"
  >;
  timeLeftAt?: Date;
  requestReplacementReason?: string;
}

export function getWorkerLeftEarlyMetadata(params: GetWorkerLeftEarlyMetadataParams) {
  const { user, shift, requestReplacementReason, timeLeftAt } = params;
  return {
    shiftId: shift._id,
    workerId: shift.agentId,
    workplaceId: shift.facility?.userId,
    workplaceUserId: user?._id,
    app: "web",
    start: shift.start,
    canRequestReplacement: shift.canRequestReplacement,
    clockIn: shift.clockInOut?.start,
    createdAt: new Date().toISOString(),
    requestReplacementReason,
    timeLeftAt,
  };
}
